const punct =
  '\\[' +
  '\\!' +
  '\\"' +
  '\\#' +
  '\\$' +
  '\\%' +
  '\\&' +
  "\\'" +
  '\\(' +
  '\\)' +
  '\\*' +
  '\\+' +
  '\\,' +
  '\\\\' +
  '\\-' +
  '\\.' +
  '\\/' +
  '\\:' +
  '\\;' +
  '\\<' +
  '\\=' +
  '\\>' +
  '\\?' +
  '\\@' +
  '\\[' +
  '\\]' +
  '\\^' +
  '\\_' +
  '\\`' +
  '\\{' +
  '\\|' +
  '\\}' +
  '\\~' +
  '\\]';

const regex = new RegExp(
  '(' + // start capture group #1
  '\\.{3}' + // ellipsis (must appear before punct)
  '|' + // alternator
  '\\w+\\-\\w+' + // hyphenated words (must appear before punct)
  '|' + // alternator
  '\\w+\\’\\w+' +
  '|' + // alternator
  "\\w+'(?:\\w+)?" + // compound words (must appear before punct)
  '|' + // alternator
  '\\w+' + // other words
  '|' + // alternator
  '[' +
  punct +
  ']' + // punct
    ')' // end capture group
);

export default text => {
  return text.split(regex);
};
